<div class="modal fade pr-0" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-image">
    <div class="modal-content ">
      <div class="image-modal-content">
        <div class="modal-body image-modal-body text-center ">
          <carousel [isAnimated]="true" [interval]="3000" [noPause]="false" [noWrap]="false">
            <slide *ngFor="let item of imageArray">
              @if (item.isImage) {
                <img [src]="item.image" class="d-block w-100" style="height: 550px; object-fit: contain;" alt="slide">
              } @else {
                <video [src]="item.video" class="d-block w-100" style="height: 550px; object-fit: contain;" [controls]="true"></video>
              }
            </slide>
          </carousel>
        </div>
        <div class="modal-header image-modal-header justify-content-center mt-4">
          @if (user_role.role_type === 'Admin') {
            <div class="image-modal-header-inner pr-3 pl-3">
              @if (isavailablefeature('delete')) {
                <button (click)="deleteImage()">
                  <i class="fa fa-trash"></i>
                </button>
              }
            </div>
          }
          <div class="image-modal-header-inner pr-3 pl-3">
            <button (click)="gotoGallery()" data-bs-dismiss="modal">
              <img src="../../../../assets/images/gallery-icon-m.svg" alt="">
            </button>
          </div>
          <div class="image-modal-header-inner pl-3 pr-3">
            <button data-bs-dismiss="modal" aria-label="Close">
              <img src="../../../../assets/images/cross-icon.svg" alt="">
            </button>
          </div>

        </div>
      </div>


    </div>

  </div>
</div>
